import React, { useEffect, useState, useRef } from "react";
import "./FileChecksModal.scss";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
} from "@ey-xd/motif-react";

// Modal component for displaying file header extraction progress
export const FileChecksModal = ({
  show,
  onClose,
}) => {
  const [countdown, setCountdown] = useState(5);
  const onCloseRef = useRef(onClose);

  // Keep the ref updated with the latest onClose
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // Auto-close modal after 5 seconds
  useEffect(() => {
    if (!show) {
      setCountdown(5); // Reset countdown when modal is closed
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onCloseRef.current();
          return 5;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show]);

  return (
    <MotifModal
      show={show}
      onClose={onClose}
      size="xl"
      className="file-checks-modal"
    >
      <MotifModalHeader>Extracting Headers</MotifModalHeader>
      <MotifModalBody>
        <div className="extracting-headers-container">
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
          <p className="extracting-message">
            Please wait while we extract headers from the attached files
          </p>
          <p className="extracting-submessage">
            You can close this window or it will close automatically in {countdown} second{countdown !== 1 ? "s" : ""}.
            You will be notified once uploaded files are ready for Mapping.
          </p>
        </div>
      </MotifModalBody>
    </MotifModal>
  );
};
